export default __webpack_public_path__ + "static/media/logo-blue.cbec8ef1.svg";